// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.father[data-v-ba8196a4]{\r\n display: flex;\r\n flex-direction: row-reverse;\n}\r\n", ""]);
// Exports
module.exports = exports;
